export default {
  message: {
    Top: {
      hello_welcome: 'Hallo, Willkommen'
    },

    Login: {
      badCredentials: 'Bad credentials',
      fillRequiredFields: 'Fill required fields',
      info: 'Login to manage your account',
      signIn: 'Sign in',
      welcome: 'Welcome back',
    },

    Author: {
      title: 'Autoren',
      header: 'Author',
      name: 'Name',
      description: 'Beschreibung',
      books: 'books',
    },

    Impressum: {
      default: 'Restore default',
      restore: 'Restore',
      restoreDefault: 'Restore default',
      restoreDefaultInfo: 'Are you sure?',
      successfullyRestored: 'Successfully restored',
      title: 'Impressum',
    },

    Slider: {
      title: 'Slider',
      commit: 'Commit changes',
      database: 'Books in database',
      slider: 'Books in slider',
      default: 'Restore default',
      restore: 'Restore',
      restoreDefault: 'Restore default',
      restoreDefaultInfo: 'Are you sure?',
      successfullyRestored: 'Successfully restored',
      commitChanges: 'Commit changes',
      commitChangesInfo: 'Record will be stored',
      successfullySaved: 'Successfully saved',
    },

    Configuration: {
      commit: 'Commit changes',
      default: 'Restore default',
      headerColor: 'Header color',
      restore: 'Restore',
      restoreDefault: 'Restore default values',
      restoreDefaultInfo: 'Changes need to be saved to takes effect',
      save: 'Save changes',
      successfullyRestored: 'Successfully restored',
      successfullySaved: 'Successfully saved',
      title: 'Configuration',
      googleAdsScript: 'Google ads script',
    },

    Backups: {
      backupedCollections: 'Backuped collections',
      create: 'Create backup',
      downloadJSON: 'Create and download JSON',
      ended: 'Ended at {ended}',
      processing: 'Processing',
      title: 'Backups',
    },

    Book: {
      books: 'Bücher',
      bookList: 'Bücherliste',
      header: 'Buchdaten',
      title: 'Title',
      displayed: 'Displayed',
      displayedTimes: '{times} times',
      author: 'Author',
      category: 'Category',
      categories: 'Kategorien',
      edition: 'Edition',
      previousEdition: 'Previous edition',
      slug: 'Slug',
      isbn: 'ISBN',
      pageCount: 'Page count',
      price: 'Price',
      rating: 'Rating',
      publicationDate: 'Publication date',
      type: 'Type',
      format: 'Format',
      language: 'Language',
      publisher: 'Publisher',
      shopLinks: 'Shop links',

      images: 'Images',

      sectionFileUploader: 'Uploader',
      dragAndDrop: 'Drag and drop or',
      selectFiles: 'Select files',
      selectFile: 'Select file',

      errors: {
        fillRequiredFields: 'Fill requested fields',
        authors: 'Authors can\'t be null'
      }
    },

    ShopLinks: {
      addLink: 'Add link',
      link: 'Link',
      label: 'Label'
    },

    Lawyer: {
      title: 'Anwälte',
      header: 'Anwälte',
      add: 'Anwälte hinzufügen',
      sectionFileUploader: 'Photo upload',
      dragAndDrop: 'Drag and drop',
      selectFiles: 'Select photo',
      categories: 'Categories',
      default: 'Default anwälte',
      errors: {
        categories: 'Fill requested field',
        fillRequiredFields: 'Fill requested fields',
      }
    },

    Publisher: {
      editPublisher : 'Edit publisher',
      editPublisherInfo: 'Edited will be changed for all books',
    },

    Category: {
      title: "Rechtsgebiete",
      name: "Name",
      lawyer: 'Anwälte',
    },

    add: 'Add',
    // apply: 'Apply',
    // approve: 'Approve',
    // areYouSure: 'Are you sure?',
    // cancel: 'Cancel',
    chooseProperDate: 'Choose proper date',
    // close: 'Close',
    confirmDelete: 'Yes, im sure.',
    // connectionError: 'Connection error.',
    // createdAt: 'Created at',
    delete: 'Delete',
    default: 'Default',
    deleted: 'Deleted',
    deletedInfo: 'Book has been deleted.',
    deleteQuestion: 'Are you sure to delete belowed record?',
    // download: 'Download',
    edit: 'Edit',
    // fieldRequired: ' - field required',
    // fieldRequiredInfo: 'This field is required',
    // fillRequiredFields: 'Please fill required fields to continue.',
    forbidden: 'Forbidden!',
    // hideDetails: 'Hide details',
    // incorrectValue: 'Please provide correct value.',
    // link: 'Download the Terms & Conditions here',
    // markedToDel: 'The milestone element will be deleted.',
    // modify: 'Modify',
    // na: 'N/A',
    // no: 'No',
    // noCancel: 'I need a few more changes - please return!',
    // noChosen: 'No chosen',
    // noData: 'No data...',
    // notFoundError: 'Not found.',
    return: 'Return',
    // save: 'Save',
    // selectAll: 'Select all',
    // showDetails: 'Show details',
    submit: 'Submit',
    success: 'Success',
    successfullyAdded: 'Successfully added',
    successfullySaved: 'Successfully saved',
    successfullyUpdated: 'Successfully updated',
    thisActionIsForbidden: 'This action is forbidden',
    title: 'Librate',
    total: 'Total',
    unauthenticated: 'This action is unauthenticated',
    unprocessable: 'Unprocessable entry',
    // unselectAll: 'Unselect all',
    update: 'Update',
    // updatedAt: 'Updated at',
    // valueNotMatch: 'Entered values not match',
    // view: 'View',
    // warning: 'Warning',
    // yes: 'Yes',
    // yesImSure: 'Yes, I am sure.',
    // yesSubmit: 'Yes, I am sure.',
    // 
    logout: 'Ausloggen',
    cancel: 'Abbrechen',
    proceed: 'Erstellen',
  }
}